<div class="container">
  <div *ngIf="showError" class="alert alert-danger">
    <p>Erreur Login</p>
  </div>
  <form>
  <div class="row align-items-center mb-2 mt-2"><label for="login" class="col-sm-3">Login</label><input  [(ngModel)] ="user.login" type="text" name="login" id="log" autocomplete="off" class="form-control col-sm-9"></div>
  <div class="row align-items-center mb-2 mt-2"><label for="password" class="col-sm-3">PassWord</label><input [(ngModel)] ="user.password" type="password" name="password" id="pass" autocomplete="off" class="form-control col-sm-9"></div>
  <button type="submit" (click)="login()" class="btn btn-primary">Ok</button>
</form>
</div>